module.exports = __webpack_public_path__ + "media/images/static/common/play_icon-cf0def9189fdd21a3e52ebda27c5d4a5.png";